import { __assign } from "tslib";
import React, { useState } from 'react';
import Lottie from 'react-lottie';
import { Alert, Box, Snackbar } from '..';
import confettiData from './confetti.json';
import checkData from './check.json';
import { makeStyles } from '@mui/styles';
var useStyles = makeStyles(function () { return ({
    snackbar: {
        position: 'relative',
        top: 0,
    },
    alert: {
        pointerEvents: 'initial',
    },
    icon: {
        borderWidth: 0,
        borderStyle: 'none',
        background: 'inherit',
    },
}); });
var GlobalAlert = function (_a) {
    var alert = _a.alert, dismiss = _a.dismiss, remove = _a.remove;
    var classes = useStyles();
    var _b = useState(true), isStopped = _b[0], setStopped = _b[1];
    return (React.createElement(Snackbar, { className: classes.snackbar, open: alert.open, 
        // Using id and count will reset timeout when new alert is added
        key: alert.id + alert.count, onClose: function (_, reason) {
            reason !== 'clickaway' && dismiss(alert.id);
            setTimeout(function () {
                dismiss(alert.id);
            }, alert.timeout);
        }, TransitionProps: {
            onEntering: function () { return setStopped(false); },
            onExited: function () { return remove(alert.id); },
        } },
        React.createElement(Box, { position: "relative" },
            React.createElement(Alert, __assign({ elevation: 5, severity: alert.type, "data-severity": alert.type, className: classes.alert, onClose: function () { return dismiss(alert.id); }, "data-bw": "alert" }, (alert.type === 'success' && alert.animateIcon
                ? {
                    classes: { icon: classes.icon },
                    icon: (React.createElement(Lottie, { options: {
                            loop: false,
                            autoplay: true,
                            animationData: checkData,
                        }, isStopped: isStopped, speed: 2, height: 28, width: 28 })),
                }
                : {})),
                alert.contents,
                alert.count > 1 ? " (" + alert.count + " occurrences)" : ''),
            alert.type === 'success' && alert.showConfetti && (React.createElement(Lottie, { style: { position: 'absolute', top: 0, marginTop: -100 }, options: {
                    loop: false,
                    autoplay: true,
                    animationData: confettiData,
                    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
                }, height: 300 })))));
};
export default GlobalAlert;
//# sourceMappingURL=GlobalAlert.js.map